import axios from "axios"
import Moment from 'moment'
import { extendMoment } from 'moment-range';
import ApiStore from "./ApiStore";
const moment = extendMoment(Moment);

var querystring = require('querystring');

export class AdminStore extends ApiStore{
  constructor() {
    super();
  }

  loadConfigOfficeWorkflow(completeFunc){
    axios.get('/admin/config_office_workflow')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }
  
  saveConfigOfficeWorkflow(seq,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/admin/config_office_workflow/'+seq, postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  delConfigOfficeWorkflow(seq, completeFunc, errorFunc) {
    axios.delete('/admin/config_office_workflow/' + seq)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status == 'OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  loadConfigMechanicWorkflow(completeFunc){
    axios.get('/admin/config_mechanic_workflow')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveConfigMechanicWorkflow(seq,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/admin/config_mechanic_workflow/'+seq, postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  delConfigMechanicWorkflow(seq, completeFunc, errorFunc) {
    axios.delete('/admin/config_mechanic_workflow/' + seq)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status == 'OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  saveConfigOfficeState(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/admin/config_office_state', postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveConfigMechanicState(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/admin/config_mechanic_state', postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadConfigContinuousPaper(completeFunc){
    axios.get('/admin/config_continuous_paper')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveConfigContinuousPaper(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/admin/config_continuous_paper', postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadConfigNotifyWork(completeFunc){
    axios.get('/admin/config_notify_work')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveConfigNotifyWork(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/admin/config_notify_work', postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveRole(role_id,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/admin/role/'+role_id, postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  delRole(role_id, completeFunc, errorFunc) {
    axios.delete('/admin/role/' + role_id)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status === 'OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }
}  

export default new AdminStore()


// WEBPACK FOOTER //
// ./src/stores/AdminStore.js